import { atom } from "recoil";
import { CommonCode } from "./entities/entities/CommonCode";

export const tokenState = atom<string>({
  key: "token",
  default: "",
});
